import i18n, { type BackendModule } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import da from "./da.json";

const lazyLanguageBackend: BackendModule = {
  type: "backend",
  read(language, _namespace, callback) {
    if (language === "fo") {
      import("./fo.json")
        .then((module) => callback(null, module.default))
        .catch((error) => callback(error, false));
      return;
    }

    callback(null, da);
  },
};

i18n
  .use(lazyLanguageBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      da: { translation: da },
    },
    partialBundledLanguages: true,
    supportedLngs: ["da", "fo"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "da",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "drift-language",
    },
  });

export default i18n;
